import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, getSessionId } from "@/lib/api";
import { trackWhop } from "@/lib/whop";
import { getRef } from "@/lib/clarity";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, object = authed

  const checkMe = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (e) {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    // Returning from Emergent Google OAuth: exchange the session_id first.
    const hash = window.location.hash || "";
    if (hash.includes("session_id=")) {
      const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
      api.post("/auth/google/session", { session_id: sid, app_session_id: getSessionId() })
        .then(({ data }) => {
          if (data && data.is_new) trackWhop("complete_registration");
          setUser(data);
          window.history.replaceState(null, "", window.location.pathname + window.location.search);
        })
        .catch(() => {
          window.history.replaceState(null, "", window.location.pathname + window.location.search);
          checkMe();
        });
      return;
    }
    checkMe();
  }, [checkMe]);

  const register = async (email, password) => {
    const { data } = await api.post("/auth/register", { email, password, session_id: getSessionId(), ref: getRef() });
    setUser(data);
    return data;
  };
  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password, session_id: getSessionId() });
    setUser(data);
    return data;
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) {}
    setUser(false);
  };
  const loginGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + window.location.pathname;
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <AuthContext.Provider value={{ user, isAuthed: !!(user && user.user_id), register, login, logout, loginGoogle, refresh: checkMe }}>
      {children}
    </AuthContext.Provider>
  );
}
